import React, { useEffect, useState } from 'react'
import TimeErrorFilterFields from './components/TimeErrorFilterFields'
import { useDispatch } from 'react-redux'
import { Card, CardContent } from '@mui/material'
import moment from 'moment'
import useTitles from 'common/hooks/useTitles'
import { fetchInstances } from 'supervision/instances/InstancesSlice'
import useFetch from 'common/hooks/useFetch'
import ApplicationConf from 'conf/ApplicationConf'
import useUpdateEffect from 'common/hooks/useUpdateEffect'
import TimeErrorsTable from './components/TimeErrorsTable'
import { ServicesActions } from 'supervision/services/ServicesSlice'

const TimeErrorsApp = () => {
    const dispatch = useDispatch()

    useTitles(() => [{
        label: 'Time error',
        href: '/timeError',
    }], [])

    useEffect(() => {
        dispatch(ServicesActions.fetch())
        dispatch(fetchInstances())
    }, [dispatch])

    const [filter, setFilter] = useState({ startOfStart: moment().subtract(1, 'month').valueOf() })

    const {
        data: timeErrors = [],
        reload,
        status,
    } = useFetch(ApplicationConf.timeError.list(), { method: 'POST', body: filter })

    useUpdateEffect(() => {
        reload()
    }, [filter])

    return (
        <div style={{ paddingBottom: '50px' }}>
            <Card sx={{ marginBottom: '5px' }}>
                <CardContent>
                    <TimeErrorFilterFields
                        defaultFilter={filter}
                        onValidate={setFilter}
                    />
                </CardContent>
            </Card>
            <TimeErrorsTable
                timeErrors={timeErrors}
                reload={reload}
                status={status}
            />
        </div>
    )
}

export default TimeErrorsApp